import { cn } from '@/lib/ui/cn';
import type {
  BlockChipProps,
  ChipBorderColor,
  ChipColor,
} from '@/types/blocks';
import Image from 'next/image';

const fillClass: Record<ChipColor, string> = {
  teal: 'bg-sh-teal',
  cyan: 'bg-sh-cyan',
  cream: 'bg-sh-cream',
  tan: 'bg-sh-tan',
  white: 'bg-white',
  black: 'bg-sh-black',
  gray: 'bg-sh-gray',
  none: 'bg-transparent',
  teal_bold: 'bg-chip-teal-fill',
  cyan_bold: 'bg-sh-cyan',
  cream_bold: 'bg-chip-cream-fill',
  tan_bold: 'bg-chip-tan-fill',
};

const borderClass: Record<ChipBorderColor, string> = {
  none: 'border-transparent',
  teal: 'border-sh-teal',
  cyan: 'border-sh-cyan',
  cream: 'border-sh-cream',
  tan: 'border-sh-tan',
  white: 'border-white',
  black: 'border-sh-black',
  gray: 'border-sh-gray',
  teal_bold: 'border-chip-teal-border',
  cyan_bold: 'border-chip-cyan-border',
  cream_bold: 'border-chip-cream-border',
  tan_bold: 'border-chip-tan-border',
};

export function HeaderChip({
  text,
  icon,
  iconShow = true,
  fillColor = 'teal',
  borderColor = 'none',
  className,
  ...rest
}: BlockChipProps & React.HTMLAttributes<HTMLDivElement>) {
  if (!text && !icon) return null;

  return (
    <div
      data-component='header-chip'
      data-test='header-chip'
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-3.5 py-1',
        'text-sh-dark-gray font-medium',
        fillColor === 'black' && 'text-sh-white',
        fillClass[fillColor],
        borderClass[borderColor],
        className
      )}
      {...rest}
    >
      {iconShow && icon?.url && (
        <Image
          src={icon.url}
          alt={icon.alt || ''}
          width={18}
          height={18}
          className='size-[18px] flex-none object-contain'
        />
      )}
      {text && (
        <span className='text-sm leading-none font-bold md:text-base'>
          {text}
        </span>
      )}
    </div>
  );
}
